// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_style_checkbox__0t45D","rotate":"Checkbox_style_rotate__CCtg6"};